"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthenticated = exports.watchAuthLoading = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_router_1 = __importDefault(require("vue-router"));
const auth_1 = require("./plugins/auth");
vue_1.default.use(vue_router_1.default);
function watchAuthLoading(next, guardCallback) {
    const $auth = (0, auth_1.getInstance)();
    // If loading has already finished, check our auth state using `guard()`
    if (!$auth.loading) {
        return guardCallback($auth);
    }
    // Watch for the loading property to change before we check loggedUser
    $auth.$watch('loading', (loading) => {
        if (loading === false) {
            return guardCallback($auth);
        }
        next(false);
    });
}
exports.watchAuthLoading = watchAuthLoading;
async function isAuthenticated(to, from, next) {
    watchAuthLoading(next, async ($auth) => {
        // If the user is authenticated, continue with the route
        if ($auth.loggedUser) {
            return next();
        }
        // Otherwise, log in with a redirect back to the visited page
        $auth.loginWithRedirect({ appState: { targetUrl: to.fullPath }, mode: 'login' });
        next(false);
    });
}
exports.isAuthenticated = isAuthenticated;
exports.default = vue_router_1.default;
__exportStar(require("vue-router"), exports);
